$.IMPORT_LOADER_MARKUP = `
    <div class="d-flex justify-content-center">
        <div class="spinner-grow text-dark" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>
`;
